import { render, staticRenderFns } from "./SaveProductConfigurationModal.vue?vue&type=template&id=b98aec4c&scoped=true&"
import script from "./SaveProductConfigurationModal.vue?vue&type=script&lang=js&"
export * from "./SaveProductConfigurationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98aec4c",
  null
  
)

export default component.exports